<template>
    <div class="row m-0 g-4">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4" v-for="dado in dados" :key="dado.id">
            <div class="card product-card h-100 border-0" @click="verProduto(dado.id)">
                <!-- Image Container with Badges & Hover Overlay -->
                <div class="card-img-wrapper position-relative overflow-hidden">
                    <img 
                        v-if="dado.arquivos && dado.arquivos.length > 0"
                        key="product-img-has"
                        :src="$url+'/api/produtos/image/'+dado.arquivo_principal.id" 
                        class="card-img-top product-img" 
                        :alt="dado.nome"
                        loading="lazy">
                    <div 
                        v-else 
                        key="product-img-none"
                        class="card-img-top product-img-placeholder d-flex flex-column justify-content-center align-items-center">
                        <i class="fas fa-image fa-3x mb-2 placeholder-icon"></i>
                        <span class="small font-weight-bold placeholder-text">Sem Imagem</span>
                    </div>

                    <!-- Category Badge -->
                    <span v-if="dado.categoria" key="badge-cat" class="badge badge-category position-absolute">
                        <i class="fas fa-tag mr-1"></i> {{ dado.categoria.nome }}
                    </span>

                    <!-- Quick Details Overlay -->
                    <div class="card-img-overlay-hover d-flex align-items-center justify-content-center">
                        <span class="btn-view-quick">
                            <i class="fas fa-eye mr-2"></i> Ver Detalhes
                        </span>
                    </div>
                </div>

                <!-- Card Body -->
                <div class="card-body d-flex flex-column p-4">
                    <h5 class="product-title multi-line-truncate mb-2" :title="dado.nome">
                        {{ dado.nome }}
                    </h5>

                    <p v-if="dado.descricao_site || dado.descricao" key="desc-has" class="product-description small mb-3">
                        {{ dado.descricao_site || dado.descricao }}
                    </p>
                    <p v-else key="desc-none" class="product-description small mb-3 text-muted-custom italic">
                        Sem descrição disponível.
                    </p>

                    <!-- Footer: Price & CTA Icon -->
                    <div class="mt-auto pt-3 border-top-custom d-flex justify-content-between align-items-center">
                        <div class="d-flex flex-column">
                            <span class="price-label">Preço</span>
                            <span class="product-price">
                                <small class="currency">R$</small> {{ dado.valor_br }}
                            </span>
                        </div>
                        <button class="btn btn-action-icon rounded-circle d-flex align-items-center justify-content-center" title="Ver Detalhes">
                            <i class="fas fa-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div class="col-12 py-5 text-center" v-if="dados.length === 0" key="empty-state">
            <div class="empty-state-wrapper py-5 px-4 rounded-xl">
                <div class="empty-icon-box mb-3 mx-auto">
                    <i class="fas fa-search fa-2x"></i>
                </div>
                <h4 class="font-weight-bold mb-2 text-primary-theme">Nenhum produto encontrado</h4>
                <p class="text-secondary-theme small mb-0 max-w-400 mx-auto">
                    Tente ajustar sua pesquisa ou selecionar outra categoria para ver os produtos disponíveis.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['dados'],
        methods: {
            verProduto(id) {
                const path = '/produtos/show/' + id;
                if (this.$route.path !== path) {
                    this.$router.push(path);
                }
            }
        }
    }
</script>

<style scoped>
    /* Card Layout & Surface */
    .product-card {
        background-color: var(--surface-color);
        border-radius: 20px !important;
        transition: all 0.35s cubic-bezier(0.165, 0.84, 0.44, 1);
        cursor: pointer;
        overflow: hidden;
        border: 1px solid var(--border-color) !important;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
    }

    .product-card:hover {
        transform: translateY(-8px);
        box-shadow: 0 20px 35px rgba(0, 0, 0, 0.12) !important;
        border-color: rgba(145, 216, 247, 0.4) !important;
    }

    :root[data-theme="dark"] .product-card:hover {
        box-shadow: 0 20px 35px rgba(0, 0, 0, 0.45) !important;
        border-color: rgba(145, 216, 247, 0.3) !important;
    }

    /* Image Wrapper & Overlay */
    .card-img-wrapper {
        height: 250px;
        background-color: var(--bg-color);
        position: relative;
    }

    .product-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    }

    .product-card:hover .product-img {
        transform: scale(1.08);
    }

    .product-img-placeholder {
        height: 100%;
        background: linear-gradient(135deg, rgba(0,0,0,0.02) 0%, rgba(0,0,0,0.06) 100%);
        color: var(--text-secondary);
    }

    .placeholder-icon {
        opacity: 0.3;
    }

    .placeholder-text {
        opacity: 0.6;
        letter-spacing: 0.5px;
    }

    .card-img-overlay-hover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(15, 23, 42, 0.35);
        backdrop-filter: blur(3px);
        -webkit-backdrop-filter: blur(3px);
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    .product-card:hover .card-img-overlay-hover {
        opacity: 1;
    }

    .btn-view-quick {
        background: #ffffff;
        color: #0f172a;
        font-weight: 700;
        font-size: 0.88rem;
        padding: 10px 22px;
        border-radius: 50px;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
        transform: translateY(12px);
        transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

    .product-card:hover .btn-view-quick {
        transform: translateY(0);
    }

    /* Category Badge */
    .badge-category {
        top: 14px;
        left: 14px;
        background: rgba(255, 255, 255, 0.88);
        color: #1e293b;
        font-weight: 700;
        font-size: 0.75rem;
        padding: 7px 14px;
        border-radius: 30px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        z-index: 2;
        border: 1px solid rgba(255, 255, 255, 0.3);
    }

    :root[data-theme="dark"] .badge-category {
        background: rgba(30, 41, 59, 0.88);
        color: #f1f5f9;
        border-color: rgba(255, 255, 255, 0.1);
    }

    /* Typography */
    .product-title {
        color: var(--text-primary);
        font-size: 1.12rem;
        font-weight: 700;
        letter-spacing: -0.3px;
        line-height: 1.35;
        transition: color 0.2s ease;
    }

    .product-card:hover .product-title {
        color: var(--accent-color);
    }

    .product-description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.5;
        color: var(--text-secondary) !important;
        font-size: 0.9rem;
    }

    .border-top-custom {
        border-top: 1px solid var(--border-color);
    }

    .price-label {
        font-size: 0.68rem;
        text-transform: uppercase;
        letter-spacing: 0.8px;
        font-weight: 700;
        color: var(--text-secondary);
    }

    .product-price {
        font-size: 1.4rem;
        font-weight: 800;
        color: var(--text-primary);
        line-height: 1.1;
        letter-spacing: -0.5px;
    }

    .product-price .currency {
        font-size: 0.85rem;
        font-weight: 600;
        color: var(--text-secondary);
        margin-right: 2px;
    }

    /* Action Button Icon */
    .btn-action-icon {
        width: 42px;
        height: 42px;
        background-color: var(--bg-color);
        color: var(--text-primary);
        border: 1px solid var(--border-color);
        transition: all 0.3s ease;
    }

    .product-card:hover .btn-action-icon {
        background-color: var(--accent-color);
        color: #ffffff;
        border-color: var(--accent-color);
        transform: translateX(4px);
    }

    :root[data-theme="dark"] .product-card:hover .btn-action-icon {
        color: #0f172a;
    }

    /* Multi-line Truncate */
    .multi-line-truncate {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        min-height: 2.7em;
    }

    /* Empty State */
    .empty-state-wrapper {
        background-color: var(--surface-color);
        border: 1px dashed var(--border-color);
        border-radius: 24px;
    }

    .empty-icon-box {
        width: 76px;
        height: 76px;
        border-radius: 50%;
        background-color: var(--bg-color);
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--text-secondary);
        box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);
    }

    .max-w-400 {
        max-width: 400px;
    }
</style>